// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marketIndices {
  container-type: inline-size;
  min-width: 328px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  width: 100%;
  height: 100%;
}

.marketIndices table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
}

.marketIndices table thead th {
  box-sizing: border-box;
  height: 32px;
  border-bottom: 1px solid var(--border-line);
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-subheader);
  text-align: left;
}

.marketIndices table thead th:first-child {
  width: 48.6%;
  padding-left: 16px;
}

.marketIndices table thead th.chart-header {
  width: 14.7%;
  text-align: center;
}
.marketIndices table thead th.mobile-only-header.text-right {
  width: 36.7%;
  padding-right: 16px;
  text-align: right;
  box-sizing: border-box;
}

.marketIndices table tbody tr {
  height: 56px;
}
.marketIndices table tbody tr:nth-child(2n) {
  background-color: var(--row-dark);
}

.marketIndices table tbody td {
  padding: 8px 0px;
  box-sizing: border-box;
  vertical-align: middle;
}
.marketIndices table tbody td:first-child {
  padding-left: 16px;
}

.marketIndices .desktop-only {
  display: none;
}

.marketIndices .info {
  display: flex;
  gap: 8px;
  height: 100%;
  align-items: center;
}

.marketIndices .flag-icon {
  padding: 4px 0px;
  width: 20px;
  height: 20px;
  svg {
    width: 100%;
    height: 100%;
  }
}

.marketIndices .table-flex-column {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  min-width: 0;
  flex: 1;
}

.marketIndices .index {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-primary);
  text-decoration: none;
}

.marketIndices .index.link-enabled,
.marketIndices .name.link-enabled {
  cursor: pointer;
  color: var(--text-ticker);
}

.marketIndices .name {
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-instrument);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  display: block;
  width: 100%;
}

.marketIndices table tbody td img {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 34px;
}

.marketIndices .price {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: right;
  padding-right: 16px;
  align-items: flex-end;
  width: 100%;
  box-sizing: border-box;
}

.marketIndices .last {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
}

.marketIndices .chg {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-primary);
}

.marketIndices .up {
  color: var(--text-up-color);
}
.marketIndices .down {
  color: var(--text-down-color);
}

.marketIndices .text-right {
  text-align: right;
}
.market-indices-table-spacer {
  height: 8px;
}

@container (min-width: 768px) {
  .marketIndices .mobile-only-header,
  .marketIndices .mobile-only-cell {
    display: none;
  }

  .marketIndices .desktop-only {
    display: table-cell;
  }
  .marketIndices table tbody tr {
    height: 40px;
  }
  .marketIndices table tbody td {
    padding: 0;
  }
  .marketIndices table thead th:first-child,
  .marketIndices table thead th:last-child {
    width: auto;
  }

  .marketIndices table thead th.ctry-index-header,
  .marketIndices table tbody td.ctry-cell {
    padding-left: 24px;
  }

  .marketIndices table thead th.ctry-index-header {
    width: 8.125rem;
    min-width: 8.125rem;
    max-width: 8.125rem;
    white-space: nowrap;
    text-align: left;
  }

  .marketIndices table tbody td.ctry-cell {
    width: 2.375rem;
    min-width: 2.375rem;
    max-width: 2.375rem;
    padding-right: 0.5rem;
    text-align: left;
  }
  .marketIndices table tbody td.ctry-cell .flag-icon {
    margin: 0;
  }

  .marketIndices table tbody td.index-cell {
    width: 5.75rem;
    min-width: 5.75rem;
    max-width: 5.75rem;
    padding-right: 1rem;
    text-align: left;
  }

  .marketIndices table thead th.name-header,
  .marketIndices table tbody td.name-cell {
    width: auto;
    min-width: 0;
    padding-left: 16px;
    padding-right: 16px;
  }

  .marketIndices table thead th.chart-header {
    width: 14%;
  }
  .marketIndices table tbody td.chart-cell {
    padding-left: 0px;
    padding-right: 8px;
  }

  .marketIndices table thead th:nth-last-child(3) {
    width: 15%;
    white-space: nowrap;
  }
  .marketIndices table thead th:nth-last-child(2) {
    width: 13%;
    white-space: nowrap;
  }
  .marketIndices table thead th:nth-last-child(1) {
    width: 16%;
    white-space: nowrap;
  }

  .marketIndices .chg .nc,
  .marketIndices .chg .pc,
  .marketIndices .desktop-only .nc,
  .marketIndices .desktop-only .pc {
    font-size: 16px;
    line-height: 24px;
  }

  .marketIndices .desktop-only.name-cell .name {
    font-size: 16px;
    height: 24px;
    line-height: 24px;
  }

  .marketIndices table thead th.pct-cell,
  .marketIndices table tbody td.pct-cell {
    padding-right: 16px;
  }
}

@container (min-width: 1024px) {
  .marketIndices table thead th.ctry-index-header,
  .marketIndices table tbody td.ctry-cell {
    padding-left: 32px;
  }

  .marketIndices table thead th.pct-cell,
  .marketIndices table tbody td.pct-cell {
    padding-right: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/MarketIndicesWidget/MarketIndicesWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,+CAA+C;EAC/C,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;;IAEE,WAAW;EACb;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;;;;IAIE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":[".marketIndices {\n  container-type: inline-size;\n  min-width: 328px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  width: 100%;\n  height: 100%;\n}\n\n.marketIndices table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n  table-layout: fixed;\n}\n\n.marketIndices table thead th {\n  box-sizing: border-box;\n  height: 32px;\n  border-bottom: 1px solid var(--border-line);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-subheader);\n  text-align: left;\n}\n\n.marketIndices table thead th:first-child {\n  width: 48.6%;\n  padding-left: 16px;\n}\n\n.marketIndices table thead th.chart-header {\n  width: 14.7%;\n  text-align: center;\n}\n.marketIndices table thead th.mobile-only-header.text-right {\n  width: 36.7%;\n  padding-right: 16px;\n  text-align: right;\n  box-sizing: border-box;\n}\n\n.marketIndices table tbody tr {\n  height: 56px;\n}\n.marketIndices table tbody tr:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.marketIndices table tbody td {\n  padding: 8px 0px;\n  box-sizing: border-box;\n  vertical-align: middle;\n}\n.marketIndices table tbody td:first-child {\n  padding-left: 16px;\n}\n\n.marketIndices .desktop-only {\n  display: none;\n}\n\n.marketIndices .info {\n  display: flex;\n  gap: 8px;\n  height: 100%;\n  align-items: center;\n}\n\n.marketIndices .flag-icon {\n  padding: 4px 0px;\n  width: 20px;\n  height: 20px;\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.marketIndices .table-flex-column {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n  min-width: 0;\n  flex: 1;\n}\n\n.marketIndices .index {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-primary);\n  text-decoration: none;\n}\n\n.marketIndices .index.link-enabled,\n.marketIndices .name.link-enabled {\n  cursor: pointer;\n  color: var(--text-ticker);\n}\n\n.marketIndices .name {\n  height: 14px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-instrument);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: none;\n  display: block;\n  width: 100%;\n}\n\n.marketIndices table tbody td img {\n  margin: 0px;\n  padding: 0px;\n  width: 100%;\n  height: 34px;\n}\n\n.marketIndices .price {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: right;\n  padding-right: 16px;\n  align-items: flex-end;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.marketIndices .last {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.marketIndices .chg {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-primary);\n}\n\n.marketIndices .up {\n  color: var(--text-up-color);\n}\n.marketIndices .down {\n  color: var(--text-down-color);\n}\n\n.marketIndices .text-right {\n  text-align: right;\n}\n.market-indices-table-spacer {\n  height: 8px;\n}\n\n@container (min-width: 768px) {\n  .marketIndices .mobile-only-header,\n  .marketIndices .mobile-only-cell {\n    display: none;\n  }\n\n  .marketIndices .desktop-only {\n    display: table-cell;\n  }\n  .marketIndices table tbody tr {\n    height: 40px;\n  }\n  .marketIndices table tbody td {\n    padding: 0;\n  }\n  .marketIndices table thead th:first-child,\n  .marketIndices table thead th:last-child {\n    width: auto;\n  }\n\n  .marketIndices table thead th.ctry-index-header,\n  .marketIndices table tbody td.ctry-cell {\n    padding-left: 24px;\n  }\n\n  .marketIndices table thead th.ctry-index-header {\n    width: 8.125rem;\n    min-width: 8.125rem;\n    max-width: 8.125rem;\n    white-space: nowrap;\n    text-align: left;\n  }\n\n  .marketIndices table tbody td.ctry-cell {\n    width: 2.375rem;\n    min-width: 2.375rem;\n    max-width: 2.375rem;\n    padding-right: 0.5rem;\n    text-align: left;\n  }\n  .marketIndices table tbody td.ctry-cell .flag-icon {\n    margin: 0;\n  }\n\n  .marketIndices table tbody td.index-cell {\n    width: 5.75rem;\n    min-width: 5.75rem;\n    max-width: 5.75rem;\n    padding-right: 1rem;\n    text-align: left;\n  }\n\n  .marketIndices table thead th.name-header,\n  .marketIndices table tbody td.name-cell {\n    width: auto;\n    min-width: 0;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .marketIndices table thead th.chart-header {\n    width: 14%;\n  }\n  .marketIndices table tbody td.chart-cell {\n    padding-left: 0px;\n    padding-right: 8px;\n  }\n\n  .marketIndices table thead th:nth-last-child(3) {\n    width: 15%;\n    white-space: nowrap;\n  }\n  .marketIndices table thead th:nth-last-child(2) {\n    width: 13%;\n    white-space: nowrap;\n  }\n  .marketIndices table thead th:nth-last-child(1) {\n    width: 16%;\n    white-space: nowrap;\n  }\n\n  .marketIndices .chg .nc,\n  .marketIndices .chg .pc,\n  .marketIndices .desktop-only .nc,\n  .marketIndices .desktop-only .pc {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .marketIndices .desktop-only.name-cell .name {\n    font-size: 16px;\n    height: 24px;\n    line-height: 24px;\n  }\n\n  .marketIndices table thead th.pct-cell,\n  .marketIndices table tbody td.pct-cell {\n    padding-right: 16px;\n  }\n}\n\n@container (min-width: 1024px) {\n  .marketIndices table thead th.ctry-index-header,\n  .marketIndices table tbody td.ctry-cell {\n    padding-left: 32px;\n  }\n\n  .marketIndices table thead th.pct-cell,\n  .marketIndices table tbody td.pct-cell {\n    padding-right: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
